export var USER_STATUS = "USER_STATUS";
export var USER_STATUS_ERROR_DATA = " USER_STATUS_ERROR_DATA";
export var USER_STATUS_HIDE_ERROR_DATA = "USER_STATUS_HIDE_ERROR_DATA";
export var USER_STATUS_START_LOADER = "   USER_STATUS_START_LOADER";
export var USER_STATUS_STOP_LOADER = "USER_STATUS_STOP_LOADER";
export var FLUSH_USER_STATUS = "FLUSH_USER_STATUS";
